import { forwardRef, useEffect, useRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBRow, MDBCol } from "mdbreact";

import "./D4TimeSpentAtSea.scss";

import { Button, Label, TextArea } from "abs-ui-components";

import { AUTOSAVE_SUCCESS_MESSAGE, DCommonTableLabel } from "../../Constants";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { API_ROUTES } from "../../ApiRoutes/ApiRoutes";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import AutoSave from "../../../../../common/AutoSave/AutoSave";

const D4TimeSpentAtSea = forwardRef(({ D4TimeSpentAtSea,vesselMstId, refetchMonitoringData }, ref) => {
    const { control, getValues, reset, formState } = useFormContext();
    const { isDirty } = formState;
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    useEffect(() => {
        if (D4TimeSpentAtSea) {
            reset(prev => ({ ...prev, d4: D4TimeSpentAtSea }));
        }
    }, [D4TimeSpentAtSea, reset]);

    AutoSave(ref, [], async () => {
        if (!isDirty) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("d4");
        const payload = {
            ...filteredFields.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const D4TimeSpentAtSea = await callApi({
                method: "POST",
                url: API_ROUTES.D4(vesselMstId),
                data: payload,
            });
            if (D4TimeSpentAtSea?.isSuccess) {
                emitToasterMsg("success", "Table D.4", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, d4: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table D.4", D4TimeSpentAtSea?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table D.4", error?.errorMessage);
        }
    };

    const filteredFields = DCommonTableLabel
        .filter((field) => field.name !== "methodDescription");

    filteredFields.splice(1, 0, {
        label: "Description of method to treat data gaps",
        name: "descriptionOfMethodToTreatDataGaps",
        maxLength: 4000,
    });

    return (
        <div className="d3-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of method</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">
                        Method to treat data gaps regarding time spent at sea
                    </h6>
                </MDBCol>
            </MDBRow>

            {filteredFields.map(({ label, name, maxLength, type }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`d4.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`d4_${name}`}
                                    className="textarea-resize"
                                    value={field.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}

            <div className="text-center">
                <Button id="d4_save_btn"
                    disabled={!isDirty}
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}>
                    Save
                </Button>
            </div>
        </div>
    );
});

export default D4TimeSpentAtSea;
